/**
 * Check if a URL is a `blob:` URL
 */
export const isBlobUrl = (url: string): boolean => Boolean(url && url.startsWith('blob:'));
